<template>
  <div>
    <vs-table :data="users">
      <template slot="header">
        <div style="width: 100%">


          <vs-row >


            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
              <h3>Location</h3>
            </vs-col>



            <vs-col  vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">


 

              <vs-select class="selectExample" v-model="select1">
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in options1"
                />
              </vs-select>




            </vs-col>




          </vs-row>
        </div>
      </template>

      <template slot="thead">
        <vs-th> Email </vs-th>
        <vs-th> Name </vs-th>
        <vs-th> website </vs-th>
        <vs-th> Nro </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          :state="
            indextr == 2 || indextr == 5 ? 'success' : indextr == 6 ? 'danger' : null
          "
          :key="indextr"
          v-for="(tr, indextr) in data"
        >
          <vs-td :data="data[indextr].email">
            {{ data[indextr].email }}
          </vs-td>

          <vs-td :data="data[indextr].username">
            {{ data[indextr].username }}
          </vs-td>

          <vs-td :data="data[indextr].id">
            {{ data[indextr].website }}
          </vs-td>

          <vs-td :data="data[indextr].id">
            {{ data[indextr].id }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  name: "LoSetting",
  data() {
    return {
      select1Normal: "",
      select1: 2,
      select2: 7,
      select3: 2,
      select4: 5,
      options1: [
        { text: "IT", value: 0 },
        { text: "Select location", value: 2 },
        { text: "Thor Ragnarok", value: 3 },
      ],
      users: [
        {
          id: 1,
          name: "Leanne Graham",
          username: "Bret",
          email: "Sincere@april.biz",
          website: "hildegard.org",
        },
        {
          id: 2,
          name: "Ervin Howell",
          username: "Antonette",
          email: "Shanna@melissa.tv",
          website: "anastasia.net",
        },
        {
          id: 3,
          name: "Clementine Bauch",
          username: "Samantha",
          email: "Nathan@yesenia.net",
          website: "ramiro.info",
        },
        {
          id: 4,
          name: "Patricia Lebsack",
          username: "Karianne",
          email: "Julianne.OConner@kory.org",
          website: "kale.biz",
        },
        {
          id: 5,
          name: "Chelsey Dietrich",
          username: "Kamren",
          email: "Lucio_Hettinger@annie.ca",
          website: "demarco.info",
        },
        {
          id: 6,
          name: "Mrs. Dennis Schulist",
          username: "Leopoldo_Corkery",
          email: "Karley_Dach@jasper.info",
          website: "ola.org",
        },
        {
          id: 7,
          name: "Kurtis Weissnat",
          username: "Elwyn.Skiles",
          email: "Telly.Hoeger@billy.biz",
          website: "elvis.io",
        },
        {
          id: 8,
          name: "Nicholas Runolfsdottir V",
          username: "Maxime_Nienow",
          email: "Sherwood@rosamond.me",
          website: "jacynthe.com",
        },
        {
          id: 9,
          name: "Glenna Reichert",
          username: "Delphine",
          email: "Chaim_McDermott@dana.io",
          website: "conrad.com",
        },
        {
          id: 10,
          name: "Clementina DuBuque",
          username: "Moriah.Stanton",
          email: "Rey.Padberg@karina.biz",
          website: "ambrose.net",
        },
      ],
    };
  },
};
</script>

<style></style>
